import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { contactUs, resetUser } from "../../redux/slices/auth/authSlice";
import OgImage from "../../assets/landingPages/homePage/Hero.png";
import { ReactComponent as WhiteFillTwitter } from "../../assets/landingPages/twitterWhite.svg";
import { ReactComponent as WhiteFillInsta } from "../../assets/landingPages/instaWhite.svg";
import { ReactComponent as WhiteFillIn } from "../../assets/landingPages/inWhite.svg";

import HeroEllipseGroup from "../../assets/landingPages/aboutHeroEllipsGroup.png";
import GetInTuchEllips from "../../assets/landingPages/getInTuchEllips.png";
import toast from "react-hot-toast";
import { useForm, Controller } from "react-hook-form";
import useSettings from "../../hooks/useSettings";
import useLocales from "../../hooks/useLocales";

import {
  PhoneInput,
  defaultCountries,
  parseCountry,
  buildCountryData,
} from "react-international-phone";
import { PhoneNumberUtil } from "google-libphonenumber";
import "react-international-phone/style.css";
import { Helmet } from "react-helmet";

const newCountries = defaultCountries
  .map(parseCountry)
  .filter((parsedCountry) => parsedCountry.name !== "Israel")
  .map(buildCountryData);

const phoneUtil = PhoneNumberUtil.getInstance();

const inputClasses =
  "dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark dark:bg-dark-secondary border text-heading_color text-small2 md:text-body_copy2 rounded-md focus:outline-none block w-full p-[13px] py-[5px] px-[15px] md:p-[15px] md:py-[7px]";
const inputErrorClasses =
  "border-state_color_error placeholder:text-state_color_error";
const inputNoErrorClasses =
  "border-light_bg_v2 focus:placeholder:text-heading_color focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color";

const ContactUs = () => {
  const { translate, currentLang } = useLocales();
  const { themeDirection } = useSettings();
  // const isPhoneValid = (phone) => {
  //   try {
  //     return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
  //   } catch (error) {
  //     return translate("front_end_pages.contact.enter_valid_number");
  //   }
  // };

  const isPhoneValid = (phone) => {
    const countryCodePattern = /^\+(\d{1,3})$/; // Regular expression to match country code
    if (
      !phone ||
      phone.trim() === "" ||
      countryCodePattern.test(phone.trim())
    ) {
      // If input is empty, contains only whitespace, or matches the country code pattern, return true
      return true;
    }
    try {
      const parsedPhoneNumber = phoneUtil.parseAndKeepRawInput(phone);
      if (!phoneUtil.isValidNumber(parsedPhoneNumber)) {
        // Return error message only if the phone number is invalid
        return translate("front_end_pages.contact.enter_valid_number");
      }
      return true; // Return true if the phone number is valid
    } catch (error) {
      // If parsing fails, return the error message
      return translate("front_end_pages.contact.enter_valid_number");
    }
  };

  const dispatch = useDispatch();
  const { darkMode } = useSelector((state) => state.theme);
  const { contactUsData } = useSelector((state) => state.user);
  useEffect(() => {
    if (contactUsData?.status === "success") {
      toast.success(contactUsData?.message, { position: "top-right" });
      dispatch(resetUser());
    } else if (contactUsData?.status === "failed") {
      toast.error(contactUsData?.message, { position: "top-right" });
      dispatch(resetUser());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactUsData]);

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  // const SubmitHandler = (data) => {
  //   dispatch(contactUs(data));
  //   reset();
  // };

  const SubmitHandler = (data) => {
    const { phoneNumber } = data;

    // Attempt to parse and validate the phone number
    try {
      const parsedPhoneNumber = phoneUtil.parseAndKeepRawInput(phoneNumber);
      if (!phoneUtil.isValidNumber(parsedPhoneNumber)) {
        // If the parsed phone number is not valid, display an error message
        toast.error("Enter a valid Phone Number");
        return; // Prevent form submission
      }
    } catch (error) {
      // If parsing fails, display an error message
      toast.error("Enter a valid Phone Number");
      return; // Prevent form submission
    }

    // Proceed with form submission if phone number is valid
    dispatch(contactUs(data));
    reset(); // Reset form fields after submission
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Contact Us | Bil.Bio</title>
        <meta property="og:title" content="Contact Us | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content={currentLang?.value} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      <section className="-mt-[93px]  bg-[#fbf7f7] dark:bg-dark-primary pt-[93px]">
        <img
          className="absolute top-0 left-0 h-[15rem] lg:h-[30rem]"
          src={HeroEllipseGroup}
          alt=""
        />
        <div className="flex justify-center">
          <div className="2xl:max-w-screen-xl xl:max-w-screen-lg w-full">
            <div className="relative px-6 smm:px-8 xsmfold:pt-12 pt-28 py-12">
              <div className="flex justify-center">
                <div className="text-center xl:w-1/2 xl:px-14">
                  <h1 className="text-custom_h4 sm:text-custom_h3 md:text-custom_h2 lg:text-custom_h1 mb-10 dark:text-color_v1_dark">
                    {/* Contact Us */}
                    {translate("header.contact_us")}
                  </h1>
                </div>
              </div>
              <div className="flex justify-center items-center xsmfold:mb-7 mb-16 2xl:mb-20">
                <div
                  className={`bg-white dark:bg-dark-secondary ${
                    darkMode ? "" : "shadow-gray-200 shadow-lg"
                  } p-5 xsmfold:p-3 w-full rounded-3xl flex flex-col lg:flex-row gap-10 sm:gap-6`}
                >
                  <div className="lg:w-2/5 min-h-[12rem] md:min-h-[14rem] bg-gradient-to-br from-[#FF765C] to-[#FF5349] p-6 px-8 xsmfold:p-3 xsmfold:px-4 xsml:p-6 xsml:py-[30px] md:px-8 md:p-6 lg:px-5 xl:px-8 relative text-white rounded-2xl flex flex-col justify-between">
                    <div>
                      <h6 className="text-body_copy1_b sm:text-custom_h6 lg:text-custom_h5 xsmfold:mb-2 mb-4">
                        {/* GET IN TOUCH */}
                        {translate("front_end_pages.about.get_in_touch")}
                      </h6>
                      <p className="text-small1 sm:text-body_copy2 md:text-body_copy1 xl:text-custom_h6r">
                        {/* Fill up your contact */}
                        {translate(
                          "front_end_pages.contact.fill_up_your_contact"
                        )}{" "}
                        <br /> {/* information and our team */}
                        {translate(
                          "front_end_pages.contact.information_and_our_team"
                        )}
                        <br /> {/* will get back to you. */}{" "}
                        {translate(
                          "front_end_pages.contact.will_get_back_to_you"
                        )}
                      </p>
                    </div>
                    <div className="flex gap-2.5 mt-[60px] smm:mt-5 sm:mt-7 md:mt-8">
                      <a
                        href="https://twitter.com/BilBioHQ"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <WhiteFillTwitter className="max-h-7 md:max-h-fit" />
                      </a>
                      <a
                        href="https://instagram.com/bil.bio"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <WhiteFillInsta className="max-h-7 md:max-h-fit" />
                      </a>
                      <a
                        href="https://www.linkedin.com/company/bilbio/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <WhiteFillIn className="max-h-7 md:max-h-fit" />
                      </a>
                    </div>
                    <div className="absolute bottom-0 right-0">
                      <img src={GetInTuchEllips} alt="" />
                    </div>
                  </div>
                  <div className="w-full p-1 lg:p-6">
                    <form
                      onSubmit={handleSubmit((data) => SubmitHandler(data))}
                    >
                      <div className="grid gap-6 mb-6 md:grid-cols-2">
                        <div>
                          <label
                            htmlFor="first_name"
                            className="block ms-[15px] mb-2 text-small2 sm:text-body_copy2 text-heading_color dark:text-color_v1_dark"
                          >
                            {/* First name */}
                            {translate("firstName")}
                          </label>
                          <input
                            type="name"
                            id="first_name"
                            {...register("firstName", {
                              required: translate(
                                "descriptions.firstName_required"
                              ),
                              // pattern: {
                              //   value: /^[A-Za-z]+$/,
                              //   message: translate(
                              //     "descriptions.firstName_must_alphabets"
                              //   ),
                              // },
                            })}
                            className={`${inputClasses} ${
                              errors?.firstName
                                ? inputErrorClasses
                                : inputNoErrorClasses
                            }`}
                            placeholder={translate(
                              "front_end_pages.contact.enter_first_name"
                            )}
                          />
                          {errors?.firstName && (
                            <small className="text-state_color_error text-small3">
                              {errors?.firstName?.message}
                            </small>
                          )}
                        </div>
                        <div>
                          <label
                            htmlFor="lastName"
                            className="block ms-[15px] mb-2 text-heading_color text-small2 sm:text-body_copy2 dark:text-color_v1_dark"
                          >
                            {/* Last name */}
                            {translate("front_end_pages.contact.last_name")}
                          </label>
                          <input
                            type="lastName"
                            id="lastName"
                            {...register("lastName", {
                              required: translate(
                                "front_end_pages.contact.last_name_required"
                              ),
                              // pattern: {
                              //   value: /^[A-Za-z]+$/,
                              //   message: translate(
                              //     "descriptions.lastName_must_alphabets"
                              //   ),
                              // },
                            })}
                            className={`${inputClasses} ${
                              errors?.lastName
                                ? inputErrorClasses
                                : inputNoErrorClasses
                            }`}
                            placeholder={translate(
                              "front_end_pages.contact.enter_last_name"
                            )}
                          />
                          {errors?.lastName && (
                            <small className="text-state_color_error text-small3">
                              {errors?.lastName?.message}
                            </small>
                          )}
                        </div>
                        <div>
                          <label
                            htmlFor="email"
                            className="block ms-[15px] mb-2 text-heading_color text-small2 sm:text-body_copy2 dark:text-color_v1_dark"
                          >
                            {/* Email */}
                            {translate("email")}&nbsp;
                            <span className="md:hidden">
                              {translate("address")}
                            </span>
                          </label>
                          <input
                            type="email"
                            id="email"
                            {...register("email", {
                              required: translate(
                                "descriptions.email_required"
                              ),
                              validate: {
                                maxLength: (v) =>
                                  v.length <= 50 ||
                                  translate(
                                    "front_end_pages.contact.the_email_should_have_less_then_characters"
                                  ),
                                matchPattern: (v) =>
                                  /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                                    v
                                  ) || translate("descriptions.valid_email"),
                              },
                            })}
                            className={`${inputClasses} ${
                              errors?.email
                                ? inputErrorClasses
                                : inputNoErrorClasses
                            }`}
                            placeholder={translate(
                              "front_end_pages.contact.enter_email"
                            )}
                          />
                          {errors?.email && (
                            <small className="text-state_color_error text-small3">
                              {errors?.email?.message}
                            </small>
                          )}
                        </div>

                        <div id="phoneGroup" dir={themeDirection}>
                          <label
                            htmlFor="phoneNumber"
                            id="phoneNumber"
                            dir={themeDirection}
                            className="block ms-[15px] mb-2 text-heading_color dark:text-color_v1_dark text-small2 sm:text-body_copy2 "
                          >
                            {translate("front_end_pages.contact.phone_number")}
                          </label>
                          <Controller
                            name="phoneNumber"
                            control={control}
                            rules={{
                              validate: (val) => isPhoneValid(val),
                              required: {
                                value: true,
                                message: translate(
                                  "front_end_pages.contact.phone_number_required"
                                ),
                              },
                            }}
                            render={({ field: { onChange, value } }) => (
                              <PhoneInput
                                value={value}
                                defaultCountry="kw"
                                inputStyle={{ border: "0px", width: "100%" }}
                                id="phoneNumber"
                                onChange={onChange}
                                countries={newCountries}
                                placeholder={translate(
                                  "front_end_pages.contact.enter_phone_number"
                                )}
                                className={`dark:text-color_v1_dark dark:caret-white dark:bg-dark-secondary border text-heading_color text-small2 md:text-body_copy2 rounded-md  focus:outline-none block w-full p-[13px] py-[4px] px-[15px] md:p-[15px] md:py-[7px] ${
                                  errors?.phoneNumber
                                    ? inputErrorClasses
                                    : inputNoErrorClasses
                                }`}
                              />
                            )}
                          />
                          {errors?.phoneNumber && (
                            <small className="text-state_color_error text-small3">
                              {errors?.phoneNumber?.message}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="mb-6">
                        <label
                          htmlFor="message"
                          className="block ms-[15px] mb-2 text-heading_color text-small2 sm:text-body_copy2 dark:text-color_v1_dark"
                        >
                          {/* Message */}
                          {translate("front_end_pages.contact.message")}
                        </label>
                        <div className="relative">
                          <textarea
                            rows={"4"}
                            {...register("message", {
                              required: translate(
                                "front_end_pages.contact.message_required"
                              ),
                            })}
                            className={`dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark dark:bg-dark-secondary border text-heading_color text-small2 md:text-body_copy2 rounded-md resize-none focus:outline-none block w-full p-[13px] px-[15px] md:p-[15px] ${
                              errors?.message
                                ? inputErrorClasses
                                : inputNoErrorClasses
                            }`}
                            placeholder={translate(
                              "front_end_pages.contact.enter_message_here"
                            )}
                          ></textarea>
                        </div>
                        {errors?.message && (
                          <small className="text-state_color_error text-small3">
                            {errors?.message?.message}
                          </small>
                        )}
                      </div>
                      <button
                        type="submit"
                        className="mt-2 border border-dark_bg_v2 dark:border-color_v2_dark text-dark_bg_v2 dark:text-color_v1_dark rounded-full w-full pt-[7px] pb-[6px] smm:pt-[10px] smm:pb-[9px] sm:pt-[13px] sm:pb-[12px] text-small3_b smm:text-small2_b sm:text-small1_bold"
                      >
                        {translate("send_message")}
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
